import { render, staticRenderFns } from "./IntroSetup.vue?vue&type=template&id=ab5c1b68&scoped=true"
import script from "./IntroSetup.vue?vue&type=script&lang=js"
export * from "./IntroSetup.vue?vue&type=script&lang=js"
import style0 from "./IntroSetup.vue?vue&type=style&index=0&id=ab5c1b68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5c1b68",
  null
  
)

export default component.exports